var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignPlatformIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "40px",
    viewBox: "0 0 32 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E5658F5D-2FB9-412B-AEBC-E35D2B685A6A@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ready",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets/Downloads",
    transform: "translate(-1007.000000, -527.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other",
    transform: "translate(420.000000, 508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(492.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Img",
    transform: "translate(72.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/white/_design-platform",
    transform: "translate(15.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    opacity: 0,
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2918344,28.333497 L39.2918344,32.5531299 L23.9776073,43.1781447 L8.69116219,32.5660415 L8.69116219,28.3453838 L23.9780189,38.957897 L39.2918344,28.333497 Z M8.69116219,20.0931107 L23.9780189,30.6923023 L39.2918344,20.0941354 L39.2918344,24.3094645 L23.9776073,34.9125501 L8.69116219,24.311514 L8.69116219,20.0931107 Z M26.6238883,4.73939758 L39.2918344,13.6399969 L39.2918344,15.9753564 L26.637059,24.8737013 L26.6238883,20.6464853 L35.139155,14.808189 L26.6238883,8.97440147 L26.6238883,4.73939758 Z M21.3318408,4.74855867 L21.3318408,8.9837675 L12.829539,14.8081275 L21.3318408,20.6372013 L21.3318408,24.8736398 L8.69105929,15.9851323 L8.69105929,13.630098 L21.3318408,4.74855867 Z",
    id: "Logo",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignPlatformIcon);
export default __webpack_public_path__ + "9e1c75e7c65d8f7571df18ae99fe97bf.svg";
export { ForwardRef as ReactComponent };